import { useGlobalState } from "context/GlobalStateContext";
import Head from "next/head";

interface HeroHeadProps {
  isProduction?: boolean;
}

const HeroHead = ({ isProduction }: HeroHeadProps) => {
  const { language } = useGlobalState();
  const isArabic = language?.toUpperCase() === "AR";

  return (
    <Head>
      {isProduction ? (
        <meta name="robots" content="index, follow" />
      ) : (
        <meta name="robots" content="noindex, nofollow" />
      )}

      <title>
        {isArabic
          ? "يواقيت: منصة تقييمات العملاء رقم 1 في تونس - أفضل العروض الحصرية"
          : "Yawakit: Plateforme d'avis consommateurs N°1 en Tunisie"}
      </title>
      <link
        rel="canonical"
        href={isArabic ? `https://www.yawakit.com/${language}` : "https://www.yawakit.com/"}
      />

      <link rel="alternate" hrefLang="fr" href="https://www.yawakit.com/" />
      <link rel="alternate" hrefLang="ar" href="https://www.yawakit.com/ar" />
      {/* <link rel="alternate" hrefLang="x-default" href="https://www.yawakit.com/" /> */}

      <meta
        name="description"
        content={
          isArabic
            ? "يواقيت، منصة تقييمات العملاء في تونس. اكتشف عروضًا حصرية ومنتجات متنوعة من أفضل المتاجر على وسائل التواصل الاجتماعي. تسوّقوا عبر الإنترنت بسهولة وأمان."
            : "Yawakit, la plateforme tunisienne d'avis client vous propose les meilleures offres dans toutes les catégories.Simplifie et sécurise vos achats en ligne"
        }
      ></meta>

      <meta
        property="og:title"
        content="Yawakit, la plateforme tunisienne d'avis client vous propose les meilleures offres dans toutes les catégories.Simplifie et sécurise vos achats en ligne"
      ></meta>
      <meta
        property="og:description"
        content="Trouvez les meilleures offres dans toutes les catégories sur Yawakit. Économisez sur vos achats en ligne avec nos offres exclusives en Tunisie!"
      ></meta>
      <meta
        property="og:image"
        content="https://www.yawakit.com/_next/image?url=%2Fimages%2Fyawakit_logo.png&w=256&q=75"
      ></meta>
    </Head>
  );
};

export default HeroHead;
